// import React from 'react';
// import './about_us_hero.css';
// import vynlogo from '../../img/des_sec/vyn_content.svg'; // Adjust the path as necessary

// const AboutUsHero = () => {
//   return (
//     <section className="hero-container-au">
//       <div className="hero-content-au">
       
        
//         <h1 className="hero-title-au">
//           <span className='hero-title-au2'></span> <span className="highlight-text-au">Our Journey</span>
//         </h1>
        
//         <p className="hero-description-au">
//         The Why Behind WikiWorks
//         </p>
//       </div>
      
//       {/* <div className="wave-bottom-au"></div> */}
//     </section>
//   );
// };

// export default AboutUsHero;

import React, { useRef, useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import './about_us_hero.css';
import vynlogo from '../../img/des_sec/vyn_content.svg'; // Adjust the path as necessary

const AboutUsHero = () => {
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  // Intersection Observer to detect when the section is in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting); // Update inView based on visibility
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  // Animation for the title
  const titleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: {
      tension: 180,
      friction: 35,
      mass: 1
    },
    delay: inView ? 300 : 0
  });

  // Animation for the highlighted text
  const highlightAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(15px) scale(0.98)',
    config: {
      tension: 160,
      friction: 30,
      mass: 1
    },
    delay: inView ? 450 : 0
  });

  // Animation for the description
  const descriptionAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(15px)',
    config: {
      tension: 160,
      friction: 30,
      mass: 1
    },
    delay: inView ? 600 : 0
  });

  return (
    <section className={`hero-container-au ${inView ? 'animate-background' : ''}`} ref={containerRef}>
      <div className="hero-content-au">
        <animated.h1 className="hero-title-au" style={titleAnimation}>
          <span className='hero-title-au2'></span>{' '}
          <animated.span className="highlight-text-au" style={highlightAnimation}>
            Our Journey
          </animated.span>
        </animated.h1>
        <animated.p className="hero-description-au" style={descriptionAnimation}>
         Get to know the people, values, and purpose that power <br /> WikiWorks and shape everything we do.
        </animated.p>
      </div>
    </section>
  );
};

export default AboutUsHero;